import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { graphql } from "gatsby";
import ExtractRichText from "../../molecules/ExtractRichText";
import "./paraVideoPromo.scss";

export const ParagraphVideoPromo = ({ node }) => {
  const { field_component_title, field_body, relationships = {} } = node;

  const parseYTLink = (url) => {
    if (url.includes('/watch?v')) {
      return url?.replace("/watch?v=", "/embed/")
    } else if(url.includes('youtu.be/')){
      return url?.replace("youtu.be/", "youtube.com/embed/")
    } else {
      return url;
    }
  }

  const ytURL = parseYTLink(relationships?.field_video?.field_media_oembed_video)

  return (
    <div className="video-promo">
      <Container className="general-container" data-aos="fade-up">
        <Row className="d-flex align-items-center">
          <Col xs={12} md={6} className="video-promo__text-section">
            {field_component_title && (
              <h2
                data-aos="underlined"
                className="underlined underlined-bg-regalBlue video-promo__title"
              >
                {field_component_title}
              </h2>
            )}
            {field_body && <ExtractRichText richText={field_body?.value} />}
          </Col>
          <Col xs={12} md={6}>
            <div className="video-wrapper">
              <iframe
                height={relationships?.field_video?.thumbnail?.height || "500"}
                width={relationships?.field_video?.thumbnail?.width}
                src={ytURL}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphVideoPromo on paragraph__video_promo {
    id
    field_component_title
    field_section_id
    field_body {
      value
    }
    relationships {
      field_video {
        id
        field_media_oembed_video
        thumbnail {
          height
          width
        }
      }
    }
  }
`;
